import React, { useEffect, useRef } from "react";
import gsap from "gsap";
import styled from "styled-components";
import SplitType from "split-type";

const Header = () => {
  const nameRef = useRef(null);
  const text1Ref = useRef(null);
  const text2Ref = useRef(null);

  // useEffect(() => {
  //   gsap.to(".header__name span", {
  //     y: 0,
  //     opacity: 1,
  //     delay: 0.5,
  //     duration: 1,
  //   });
  // }, []);

  useEffect(() => {
    const splitTextName = new SplitType(nameRef.current, {
      types: "words, chars",
    });
    const splitText1 = new SplitType(text1Ref.current, {
      types: "words, chars",
    });
    const splitText2 = new SplitType(text2Ref.current, {
      types: "words, chars",
    });

    const tl = gsap.timeline();

    tl.from(splitTextName.chars, {
      opacity: 0,
      y: 50,
      stagger: 0.02,
      duration: 1.5,
      ease: "power4.out",
      delay: 0.5,
    });
    tl.from(
      splitText1.chars,
      {
        opacity: 0,
        y: 50,
        stagger: 0.02,
        duration: 1.5,
        ease: "power4.out",
        delay: 0.5,
      },
      "<"
    );
    tl.from(
      splitText2.chars,
      {
        opacity: 0,
        y: 50,
        stagger: 0.05,
        duration: 0.5,
        ease: "sine.out",
        delay: 0.5,
      },
      "<"
    );

    // Cleanup function to revert SplitType changes
    // return () => splitTextName.revert();
  }, []);

  return (
    <HeaderStyled>
      <header className="header">
        <div className="row">
          <h2 className="heading header__name">
            <span ref={nameRef} className="animated-text">
              maruf mia
            </span>
          </h2>
          <h1 class="heading">
            <span class="sub-text outline-text" ref={text1Ref}>
              A Dadicated
            </span>
            <div class="text-hero main-text" ref={text2Ref}>
              frontend developer
            </div>
          </h1>
        </div>
      </header>
    </HeaderStyled>
  );
};

export default Header;

const HeaderStyled = styled.div``;
